import React, { useState } from "react";
import * as bootstrap from 'bootstrap';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import Swal from "sweetalert2";
import "./InviteAuthorModal.css";

const InviteAuthorModal = ({ authorEmail, authorName, cordinatorEmail, onSuccess = () => { }, onAuthorMissingChange }) => {
    //const [fromEmail, setFromEmail] = useState("");
    const [fromEmail, setFromEmail] = useState(cordinatorEmail || "");
    const [message, setMessage] = useState(
        `We are looking forward to your upcoming event at "Demo Elementary School" here.<br/><br/>
Please click on the link below to set up your profile on AuthorMeet – <a href="https://www.authormeet.net/" target="_blank" rel="noopener noreferrer">www.authormeet.net</a><br/><br/>
This site enables you to expand your reach and connect with readers. You can promote your work, share new releases, and engage with a wide range of audiences. Whether you're offering workshops, virtual Q&A sessions, or live readings, the platform provides a seamless way to connect with event hosts and interact with readers.<br/><br/>Best Regards, <br/> Bookworm Central Team`
    );

    // Function to send the invite
    // Function to send the invite
    const sendInvite = async () => {
        if (!authorEmail) {
            alert("Please enter an author email address.");
            return;
        }
        if (!fromEmail) {
            alert("Please enter your email address.");
            return;
        }

        const coordinatorId = localStorage.getItem("cordinator_id");
        const subject = "You have Been Invited to Sign Up for AuthorMeet!";

        try {
            const params = new URLSearchParams({
                authorEmail,
                authorName,
                coordinator_id: coordinatorId,
                fromEmail,
                subject,
                message
            });

            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/send_invite.php?${params.toString()}`, {
                method: "GET"
            });

            if (!response.ok) throw new Error("Something went wrong");

            const data = await response.json();

            if (data.success) {
                Swal.fire({
                    title: "Mail Sent Successfully!",
                    text: "The invitation email was sent successfully.",
                    icon: "success",
                    timer: 2000,
                    showConfirmButton: false,
                });

                // Notify parent
                if (onSuccess) onSuccess();

                // Close the modal programmatically
                const modalEl = document.getElementById('inviteModal');
                const modalInstance = bootstrap.Modal.getInstance(modalEl); // get current instance
                if (modalInstance) {
                    modalInstance.hide();
                }

                document.body.classList.remove("modal-open");

                const backdrops = document.getElementsByClassName("modal-backdrop");
                while (backdrops.length > 0) {
                    backdrops[0].remove();
                }

                onAuthorMissingChange(false)

            } else {
                Swal.fire({
                    title: "Mail Sending Failed!",
                    text: data.message || "There was an issue sending the invitation. Please try again.",
                    icon: "error",
                    timer: 3000,
                    showConfirmButton: false,
                });
            }
        } catch (error) {
            alert("An error occurred while sending the invite.");
            console.error(error);
        }
    };



    return (
        <div className="modal fade" id="inviteModal" tabIndex="-1" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content rounded-4">
                    <div className="modal-body">
                        <div className="mb-3 row">
                            <label className="col-2 fw-semibold col-form-label">To:</label>
                            <div className="col-10">
                                <input
                                    className="form-control"
                                    placeholder="Author email address"
                                    value={authorEmail || ""}
                                    readOnly
                                />
                            </div>
                        </div>
                        <div className="mb-3 row">
                            <label className="col-2 fw-semibold col-form-label">From:</label>
                            <div className="col-10">
                                <input
                                    className="form-control"
                                    placeholder="Your email address"
                                    value={fromEmail}
                                    onChange={(e) => setFromEmail(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="mb-3 row">
                            <label className="col-2 fw-semibold col-form-label">Subject:</label>
                            <div className="col-10">
                                <input
                                    className="form-control"
                                    defaultValue="You’ve Been Invited to Sign Up for AuthorMeet!"
                                />
                            </div>
                        </div>
                        <div className="row">
                            <label className="col-2 fw-semibold col-form-label">Message:</label>
                            <div className="col-10">
                                <div
                                    className="form-control mb-4"
                                    style={{ height: "200px", overflowY: "auto" }}
                                    contentEditable
                                    dangerouslySetInnerHTML={{ __html: message }}
                                    onInput={(e) => setMessage(e.currentTarget.innerHTML)}
                                />
                            </div>
                        </div>
                        <button
                            className="btn btn-primary w-100 fw-bold sendtn"
                            onClick={sendInvite}
                        >
                            SEND
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InviteAuthorModal;
